<template>
<div>
    <div class="grid-x list-counter list-counter-simple">
        <div v-if="tasks && tasks.length > 0">
            <span>{{ tasks[0].rowCount }} opgave<span v-if="tasks.length > 1">r</span> <span v-show="taskSelected"> | opgave valgt</span></span>
            <div class="page-indicator">
                <span v-show="tasks[0].pageCount > 1">Side {{activePages['tasksSimple']}}</span>
            </div>
        </div>
        <div v-else-if="tasks && tasks.length < 1" class="noResult">
            <div>
                <span style="margin-left: 0px;">Ingen eksisterende opgaver</span>
            </div>
        </div>
        <div v-else class="flexbox-center">
            Henter opgaver...
            <div class="loader-dashboard"></div>
        </div>
    </div>

    <pagination v-show="tasks && tasks.length > 0 && tasks[0].pageCount > 1" :showPaging="tasks && tasks.length > 0 && tasks[0].pageCount > 1 ? true : false" :totalPages="tasks && tasks.length > 0 ? tasks[0].pageCount : null" :page="'tasksSimple'" :position="'right'" />
    <div v-if="tasks && tasks.length > 0" class="grid-x list-sort list-sort-simple">
        <div class="cell large-1"></div>
        <!-- Makes no sense that this sorting parameter is address1, but the backend people demands this :) -->
        <div class="cell large-4 item flexbox" @click="sort('address1')" :class="{selected: currentSort === 'address1'}">
            <span>Navn</span>
            <div>
                <icon v-if="currentSort === 'address1'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'address1'}" name="keyboard_arrow_sort" />
            </div>
        </div>
        <div class="cell large-3 item flexbox" @click="sort('requisitionedCount')" :class="{selected: currentSort === 'requisitionedCount'}">
            <span>Rekvirerede aktiviteter</span>
            <div>
                <icon v-if="currentSort === 'requisitionedCount'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'requisitionedCount'}" name="keyboard_arrow_sort" />
            </div>
        </div>
        <div class="cell large-2 item flexbox" @click="sort('ownerUser')">
            <span>Ansvarlig</span>
            <div>
                <icon v-if="currentSort === 'ownerUser'" class="small-svg fill-selected-dark-gray" :class="{rotated: !currentSortDir && currentSort === 'ownerUser'}" name="keyboard_arrow_sort" />
            </div>
        </div>
    </div>
    <transition-group name="list" tag="div">
        <div v-for="task in tasks" :key="task.taskId" @click="attachTask(task)">
            <div class="grid-x list-row supply align-items sidebar-color" :class="[{'list-row-simple': taskSelected && taskSelected.taskId === task.taskId}, businessAreaClass(task.businessAreaTypeId)]">
                <div class="cell large-1">
                    <icon class="medium-svg fill-primary" :name="task.routine ? 'task-routine' : 'task'" />
                </div>
                <div class="cell large-4 item truncate-fade truncate-fade-simple">
                    <span>{{ task.taskName }}</span>
                    <span v-if="task.address1">{{ task.address1 }}, <span v-if="task.address2">{{ task.address2 }},</span> {{ task.postalCode }} {{ task.city }}</span>
                    <span v-else>Ingen adresse</span>
                </div>
                <div class="cell large-3 item truncate-fade">
                    <span v-if="task.requisitionedCount">{{ task.requisitionedCount }} rekvirere<span v-if="task.requisitionedCount === 1">t</span><span v-if="task.requisitionedCount !== 1">de</span> aktivitet<span v-if="task.requisitionedCount > 1">er</span></span>
                    <span v-else>Ingen rekvirerede aktiviteter</span>
                    <span v-if="task.requestCount">{{ task.requestCount }} henvendelse<span v-if="task.requestCount > 1">r</span></span>
                    <span v-else>Ingen henvendelser</span>
                </div>
                <div class="cell large-2 item truncate-fade">
                    <span>{{ task.ownerUser }}</span>
                    <span>{{ task.ownerOrganization }}</span>
                </div>
                <div class="cell large-2 item flexbox-center">
                    <span class="task-status" :class="statusColor(task.status)">{{ task.status }}</span>
                </div>
            </div>
        </div>
    </transition-group>
    <pagination v-show="tasks && tasks.length > 0 && tasks[0].pageCount > 1" :showPaging="tasks && tasks.length > 0 && tasks[0].pageCount > 1 ? true : false" :totalPages="tasks && tasks.length > 0 ? tasks[0].pageCount : null" :page="'tasksSimple'" :position="'right'" />
</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import pagination from './../../../components/shared/pagination/pagination.vue'

export default {
    name: 'list-tasks',
    components: {
        pagination
    },
    props: {
        value: Array
    },
    data () {
        return {
            tasks: this.value,
            taskSelected: null
        }
    },
    watch: {
        value (tasks) {
            this.tasks = tasks
        }
    },
    computed: {
        ...mapGetters({
            currentSortDir: 'getCurrentTaskSimpleOrderByDescending',
            currentSort: 'getCurrentTaskSimpleOrderByColumnName',
            activePages: 'getActivePages',
            supplyTypes: 'getSysBusinessAreaTypeList'
        })
    },
    methods: {
        ...mapActions({
            setActivePages: 'setActivePages',
            setActivePageContextView: 'setActivePageContextView'
        }),
        sort (s) {
            let sort = this.currentSortDir
            let filterObject = {
                orderByDescending: this.currentSort !== s ? false : sort = !sort,
                orderByColumnName: s,
                tab: 'tasks',
                page: 1
            }
            this.setActivePages(filterObject)
        },
        businessAreaClass (businessAreaType) {
            if (this.supplyTypes.find(supplyType => supplyType.sysBusinessAreaTypeId === businessAreaType)) {
                return this.supplyTypes.find(supplyType => supplyType.sysBusinessAreaTypeId === businessAreaType).systemName
            }
        },
        attachTask (task) {
            this.taskSelected = task
            this.$emit('attachTask', task)
        },
        statusColor (status) {
            if (status) {
                if (status.toLowerCase() === 'i gang') {
                    return 'blue-status'
                }
                if (status.toLowerCase() === 'færdigmeldt') {
                    return 'green-status'
                }
                if (status.toLowerCase() === 'afsluttet') {
                    return 'gray-status'
                }
            }
            return 'blue-status'
        }
    },
    created () {
        this.setActivePageContextView(1)
    }
}
</script>



// WEBPACK FOOTER //
// src/components/shared/list/list-tasks-simple.vue